<template>
  <div>
    <div class="Fuell-Toolbar">
      <h3
        class="Fuell-Toolbar--subtitle"
        v-t="{path:'expense_fields_creation_subtitle'}"
      >

      </h3>

    </div>
    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3
          class="Fuell-Section--title"
          v-t="{ path: 'expense_fields_mileage_categories' }"
        ></h3>

        <button
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateMileageCategory"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{ path: 'expense_fields_new_mileage_category' }"
          >
          </span>
        </button>
      </div>
      <div>
        <mileage-category-table @editMileageCategory="showEditMileageCategory">
        </mileage-category-table>
      </div>
    </div>
    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3
          class="Fuell-Section--title"
          v-t="{ path: 'expense_fields_diet_categories' }"
        ></h3>

        <button
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateDietCategory"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{ path: 'expense_fields_new_diet_category' }"
          >
          </span>
        </button>
      </div>
      <div>
        <diet-category-table @editDietCategory="showEditDietCategory">
        </diet-category-table>
      </div>
    </div>
    <create-mileage-category-modal
      :mileageCategoryId="mileageCategoryToEditId"
      :open.sync="showCreateMileageCategoryModalFlag"
      v-if="showCreateMileageCategoryModalFlag"
    ></create-mileage-category-modal>
    <create-diet-category-modal
      :dietCategoryId="dietCategoryToEditId"
      :open.sync="showCreateDietCategoryModalFlag"
      v-if="showCreateDietCategoryModalFlag"
    ></create-diet-category-modal>
  </div>
</template>

<script>
import MileageCategoryTable from '../../_components/expense_fields/MileageCategoryTable'
import DietCategoryTable from '../../_components/expense_fields/DietCategoryTable'
const CreateMileageCategoryModal = () => import('../../_components/expense_fields/CreateMileageCategoryModal')
const CreateDietCategoryModal = () => import('../../_components/expense_fields/CreateDietCategoryModal')

export default {
  name: 'ExpenseFieldsIndex',
  components: { MileageCategoryTable, CreateMileageCategoryModal, CreateDietCategoryModal, DietCategoryTable },
  data () {
    return {
      showCreateMileageCategoryModalFlag: false,
      mileageCategoryToEditId: 0,
      showCreateDietCategoryModalFlag: false,
      dietCategoryToEditId: 0
    }
  },
  methods: {
    showCreateMileageCategory () {
      this.mileageCategoryToEditId = 0
      this.showCreateMileageCategoryModalFlag = true
    },
    showEditMileageCategory (event) {
      this.mileageCategoryToEditId = event
      this.showCreateMileageCategoryModalFlag = true
    },
    showCreateDietCategory () {
      this.dietCategoryToEditId = 0
      this.showCreateDietCategoryModalFlag = true
    },
    showEditDietCategory (event) {
      this.dietCategoryToEditId = event
      this.showCreateDietCategoryModalFlag = true
    }

  }

}
</script>
<style scoped>
@media screen and (max-width: 576px) {
  .Fuell-ToolbarButton {
    margin: 10px 0px !important;
  }
}
</style>
